import React, { useEffect, useState } from 'react';
import { demoService } from '../services/api';
import '../styles/DemoBanner.css';

// Shown on every logged-in page (mounted from App.js's ProtectedRoute wrapper)
// for demo-trial users only -- reminds them the app is still under active
// development, shows days remaining on their 5-day trial, and gives them a
// quick way to leave feedback. Renders nothing at all for normal accounts.
export default function DemoBanner() {
  const [demo, setDemo] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [sendError, setSendError] = useState('');

  useEffect(() => {
    demoService.status()
      .then(res => setDemo(res.data))
      .catch(() => setDemo(null));
  }, []);

  if (!demo || !demo.is_demo || demo.status !== 'active') return null;

  const daysLeft = Math.max(0, Math.ceil(
    (new Date(demo.expires_at) - new Date()) / (1000 * 60 * 60 * 24)
  ));

  const handleSubmitFeedback = async (e) => {
    e.preventDefault();
    if (!feedback.trim()) return;
    try {
      setSending(true);
      setSendError('');
      await demoService.submitFeedback(feedback.trim());
      setSent(true);
      setFeedback('');
    } catch (err) {
      setSendError(err.response?.data?.detail || 'Failed to send feedback — please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="demo-banner">
      <span className="demo-banner-text">
        🚧 Free trial — <strong>{daysLeft} day{daysLeft === 1 ? '' : 's'} left</strong>.
        Noctis Ledger is still under active development.
      </span>
      <button className="demo-banner-feedback-btn"
        onClick={() => { setShowFeedback(true); setSent(false); setSendError(''); }}>
        💬 Give Feedback
      </button>

      {showFeedback && (
        <div className="demo-feedback-modal-overlay" onClick={() => setShowFeedback(false)}>
          <div className="demo-feedback-modal" onClick={e => e.stopPropagation()}>
            <h3>What do you think?</h3>
            <p>Tell us what you like, what's missing, or what you'd want to see next.</p>
            {sent ? (
              <p className="demo-feedback-sent">✓ Thanks — your feedback was sent.</p>
            ) : (
              <form onSubmit={handleSubmitFeedback}>
                <textarea
                  rows={5}
                  value={feedback}
                  onChange={e => setFeedback(e.target.value)}
                  placeholder="Your thoughts..."
                  required
                />
                {sendError && <div className="error">{sendError}</div>}
                <div className="demo-feedback-modal-actions">
                  <button type="button" className="demo-feedback-close-btn"
                    onClick={() => setShowFeedback(false)}>Close</button>
                  <button type="submit" className="demo-feedback-send-btn" disabled={sending}>
                    {sending ? 'Sending...' : 'Send Feedback'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
